import type { AccountMultiFactor as AccountMultiFactorModel } from '@/adapters/catalogv1.g';

export function extractAccountMultiFactor(model: AccountMultiFactorModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    accountRef: model.account_ref ?? '',
    multiFactorRef: model.multi_factor_ref ?? '',
    status: model.status,
    instanceRef: model.instance_ref,
    createdAt: model.created_at ? new Date(model.created_at) : undefined,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogAccountMultiFactor = ReturnType<
  typeof extractAccountMultiFactor
>;
